export default __webpack_public_path__ + "static/assets/med_x_inhaler.ac3a7334.png";